import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getSelectFitLogoTypes } from "../services/RetailLocationService";

export function useSelectFitLogoTypes(enabled = true, resetKey, callback = () => {}, params) {

    const [selectFitLogoTypes, setSelectFitLogoTypes] = useState([]);

    const {data} = useQuery({
        queryKey: ['selectFitLogoTypes', resetKey, params],
        queryFn: () => getSelectFitLogoTypes(params),
        retry: false,
        enabled: enabled,
    })

    useEffect(() => {
        if (data) {
            setSelectFitLogoTypes(data.selectFitLogoTypes);
            callback(data.selectFitLogoTypes);
        }
    }, [data]);

    return selectFitLogoTypes;
}